import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {IAppSettingsWrap, IAppStatic, IUser} from "../../../interfaces";
import {retryWithBackoff} from "../../../../libs/rxjs/retryWithBackoff";
import {catchError, map} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {TranslocoService} from "@ngneat/transloco";
import {Lib} from "../../../../libs/Lib";
import {IFasterqAction} from "../../../interfaces/fasterq-interfaces";
import {Compbaser} from "../../../components/compbaser";
import {LocalStoreService, StoreSelectorsService} from "../../../services";

// const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'}), responseType: 'text' as 'json'};
// const httpOptionsJson = {headers: new HttpHeaders({'Content-Type': 'application/json'}), responseType: 'json' as 'json'};

@Injectable()
export class FasterqServices extends Compbaser {
    private user: IUser;
    private appSettings: IAppStatic;

    constructor(private translocoService: TranslocoService,
                private localStoreService: LocalStoreService,
                private _http: HttpClient,
                private storeSelector: StoreSelectorsService,
                private toast: ToastrService) {
        super();
        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.user = user;
                })
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => this.appSettings = i_appSettings)
        );
    }

    private onError(i_msg) {
        console.log('error ' + i_msg);
        this.toast.error(i_msg);
    }

    private getCredentials() {
        if (this.user) {
            // console.log('founder user in this.user');
            return Lib.EncryptUserPass(this.user.username, this.user.passwordNew);
        } else {
            this.user = this.localStoreService.getItem('IUser');
            if (this.user) {
                // console.log('founder user in local store ' + this.user.username);
                return Lib.EncryptUserPass(this.user.username, this.user.passwordNew);
            } else {
                // console.log('nothing found');
                this.toast.error('could not get logged in user name');
            }
        }
        // if (Lib.DevMode()) {
        //     return Lib.EncryptUserPass('lite28@ms.com', '123123');
        //     return Lib.EncryptUserPass(this.user.username, this.user.passwordNew);
        // } else {
        //     return Lib.EncryptUserPass(this.user.username, this.user.passwordNew);
        // }
    }

    public serverGetCommand(endPoint, authenticate): Observable<IFasterqAction> {
        const credentials = authenticate ? this.getCredentials() : "";
        const httpOptionsJson = {headers: new HttpHeaders({'Authorization': credentials}), responseType: 'json' as 'json'};
        // httpOptionsJson.headers.append('a', options);
        const url = `${this.appSettings.globalService}/${endPoint}`;
        return this._http.get<any>(url, httpOptionsJson).pipe(
            retryWithBackoff(url, this.storeSelector, this.toast),
            catchError((e) => {
                this.onError(this.translocoService.translate('general.problemFasterq', {}, this.translocoService.getActiveLang()));
                return of('problem with fasterq get ' + e);
            }),
            map((v: IFasterqAction) => ({payload: {serverReplay: v}}))
        );
    }

    public serverPutCommand(options: IFasterqAction, endPoint): Observable<IFasterqAction> {
        let credentials;
        if (options.payload.user) {
            credentials = Lib.EncryptUserPass(options.payload.user, options.payload.password);
        } else {
            credentials = this.getCredentials();
        }
        const httpOptionsJson = {headers: new HttpHeaders({'Authorization': credentials}), responseType: 'json' as 'json'};
        const url = `${this.appSettings.globalService}/${endPoint}`;
        return this._http.put<IFasterqAction>(url, options.payload, httpOptionsJson).pipe(
            retryWithBackoff(url, this.storeSelector, this.toast),
            catchError((e) => {
                this.onError(this.translocoService.translate('general.problemFasterq', {}, this.translocoService.getActiveLang()));
                return of('problem fasterq post ' + e);
            }),
            map((v: IFasterqAction) => ({payload: {serverReplay: v}}))
        );
    }

    public serverPostCommand(options: IFasterqAction, endPoint, authenticate): Observable<IFasterqAction> {
        const credentials = authenticate ? this.getCredentials() : "";
        const httpOptionsJson = {headers: new HttpHeaders({'Authorization': credentials}), responseType: 'json' as 'json'};
        const url = `${this.appSettings.globalService}/${endPoint}`;
        console.log(url);
        return this._http.post<IFasterqAction>(url, options.payload, httpOptionsJson).pipe(
            retryWithBackoff(url, this.storeSelector, this.toast),
            catchError((e) => {
                this.onError(this.translocoService.translate('general.problemFasterq', {}, this.translocoService.getActiveLang()));
                return of('problem fasterq post ' + e);
            }),
            map((v: IFasterqAction) => ({payload: {serverReplay: v}}))
        );
    }

    public removeLine(options: IFasterqAction): Observable<IFasterqAction> {
        const credentials = this.getCredentials();
        const httpOptionsJson = {headers: new HttpHeaders({'Authorization': credentials}), responseType: 'json' as 'json'};
        const url = `${this.appSettings.globalService}/Line/${options.payload.line_id}`;
        return this._http.delete<IFasterqAction>(url, httpOptionsJson).pipe(
            retryWithBackoff(url, this.storeSelector, this.toast),
            catchError((e) => {
                this.onError(this.translocoService.translate('general.problemFasterq', {}, this.translocoService.getActiveLang()));
                return of('problem loading fasterq lines ' + e);
            }),
            map((v: IFasterqAction) => ({payload: {serverReplay: v}}))
        );
    }
}


